
  import {Component, Prop, Vue, Watch} from "vue-property-decorator";
  import {RankingList, StatisticalData, deviceStatus} from "@/views/components";
  import deviceItem from "@/views/components/DeviceStatus/deviceItem";
  import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
  import Scan from "@/views/components/Scan/Scan.vue";
  import config from "./config";
  import Form1 from "./Form1.vue";
  import Form2 from "./Form2.vue";
  import FormPic from "./FormPic.vue";
  import TableHeader from "./TableHeader.vue";
  import Scan2 from "@/views/components/Scan/Scan2.vue";
  import DeviceItems2 from "@/views/components/DeviceStatus/DeviceItems2.vue";

  @Component({
    name: "scanforgetonShape2",
    components: {
      DeviceItems2,
      Scan2,
      deviceStatus,
      RankingList,
      StatisticalData,
      YtoTable,
      Form1,
      Form2,
      TableHeader,
      Scan,
      FormPic,
    },
  })
  export default class extends Vue {
    @Prop() private callbackmodel;
    @Prop() private getFormValue;
    @Prop() private storeNextOrgs;
    @Prop() private ChooseNextWebPoint;
    @Prop() private formModel2;
    @Prop() private AutoCreateCarCodeShow;
    @Prop() private AutoCreateCarCodeChangeFunc;
    @Prop() private statisticalList;
    @Prop() private ranklistdata;
    @Prop() private errormessage;
    @Prop() private deviceItems;
    // @Prop() private ytocodeget;
    // @Prop() private ytoCode;
    @Prop() private deletedatahistory;
    @Prop() private rowClassAction;
    @Prop() private showList;
    @Prop() private currentRowChanged;
    private config = config;

    public ytoCode: string = "";

    private ytocodeget(e) {
      this.$emit("ytocodeget", this.ytoCode, ...arguments);
    }
  }
